import { render, staticRenderFns } from "./OrderVersions.vue?vue&type=template&id=11f9d7d0&scoped=true"
import script from "./OrderVersions.vue?vue&type=script&lang=js"
export * from "./OrderVersions.vue?vue&type=script&lang=js"
import style0 from "./OrderVersions.vue?vue&type=style&index=0&id=11f9d7d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f9d7d0",
  null
  
)

export default component.exports